import { useContext } from 'react';
import { DialogContext, IDialogContext } from 'context';

export function useDialog(): IDialogContext {
  return useContext(DialogContext)!;
}
